<template>
    <Select v-model="model" track-by="alpha2" label="name" :options="options" :placeholder="placeholder" :hasError="hasError" />
</template>

<script>
    import Select from '../Form/Select'
    import countries from '../../lang/countries/en'

    export default {
        props: {
            'value': String,
            'placeholder': {
                type: String,
                default: 'Type to search'
            },
            'hasError': Boolean
        },
        data() {
            return {
                options: countries
            }
        },
        components: {
            Select
        },
        methods: {
            toUppercase(val) {
                return typeof val === 'string' ? val.toUpperCase() : val
            },
            toLowercase(val) {
                return typeof val === 'string' ? val.toLowerCase() : val
            }
        },
        computed:{
            model: {
                get() {
                    return this.toLowercase(this.value)
                },
                set(val) {
                    this.$emit('input', this.toUppercase(val))
                }
            }
        }
    }
</script>